import type { CartDto, UpdateCartRequest } from '../../types/api';
import { delay } from '../mock/storage';

export async function mockFetchCart(): Promise<CartDto> {
  await delay(150);
  return { items: [], subtotal: 0, currency: 'TRY', updatedAt: new Date().toISOString() };
}

export async function mockUpdateCart(_payload: UpdateCartRequest): Promise<CartDto> {
  await delay(150);
  return mockFetchCart();
}

export async function mockClearCart(): Promise<void> {
  await delay(100);
}
